module.exports = __webpack_public_path__ + "static/media/subSaharanAfrica.fbe23755.png";